import React, { useState } from "react";
import closeMenuIcon from "../../../../../assets/pepper-icons/rightbar/icon_equis.svg";
import { GetDocumentsByCompanies } from "../../../../../graphql/getDocsByCompanies";
import { useDispatch, useSelector } from "react-redux";
import TablaDocumentos from "../../../../documentostributarios/TablaDocumentos";
import "./eerrDetail.scss";
import moment from "moment";
export default function EerrDetail({ closeMenu }) {
  const { detailEerr } = useSelector((state) => state.eerr);
  const { selectedCompany } = useSelector((state) => state.companyList);
  const [limit, setLimit] = useState(30);
  const variables = {
    companyId: selectedCompany.id,
    pagination: { limit: limit, page: 1 },
    documentTypes: ["TAX_DOCUMENT", "OBLIGATION"],
    filter: "ALL",
    search: "",
    newFilter: {
      dates: [detailEerr.column.startDate, detailEerr.column.endDate],
      eerrArea: detailEerr.eerrArea,
    },
  };
  const docs = GetDocumentsByCompanies(variables);

  return (
    <div className="detailContainer">
      <div className="detailContainer__header">
        <h5 className="detailContainer__header__title">
          {detailEerr.eerrArea +
            " " +
            moment(detailEerr.column.startDate).format("DD/MM/YY") +
            " - " +
            moment(detailEerr.column.endDate).format("DD/MM/YY")}
        </h5>
        <img
          src={closeMenuIcon}
          alt="closeModal"
          className="detailContainer__header__img"
          onClick={() => closeMenu()}
        />
      </div>
      <div className="detailContainer__listContainer">
        <TablaDocumentos
          data={docs.data}
          fetching={docs.fetching}
          limit={limit}
          selected={"ALL"}
          small={true}
          setLimit={(state) => setLimit(state)}
        />
      </div>
    </div>
  );
}
